export const copyLinkSuccess = {
  title: 'リンクがコピーされました',
};
